import React from 'react'
import { Button, Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useDeleteCategoryMutation } from '../../../../../../store/apis/question.api'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'
import useSubmissionGroups from '../../../submissions/submission-groups/useSubmissionGroups'
import { SubmissionGroupByTypes } from '../../../../../../constants/groups-by-types'
import { useAssignmentAccess } from '../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../constants/assignment-permissions'

const DeleteCategoryButton = ({ categoryId, questionId, onSuccess }) => {
    const [deleteCategory] = useDeleteCategoryMutation()
    const hasEditPermission = useAssignmentAccess([AssignmentPermissions.CAN_EDIT])

    // Get groups with submissions count for this category
    const { groups } = useSubmissionGroups({
        applyFilter: false,
        groupBy: SubmissionGroupByTypes.CATEGORY,
        questionId: questionId
    })
    const categoryGroup = groups.find(group => group.id === categoryId)
    const submissionsCount = categoryGroup?.submissions?.length || 0

    const handleDelete = async () => {
        Modal.confirm({
            title: 'Are you sure you want to delete this category?',
            icon: <ExclamationCircleOutlined />,
            content: `This action cannot be undone. ${submissionsCount ? `${submissionsCount} submissions currently classified in this category will be marked as "unclassified".` : ''}`,
            okText: 'Delete',
            okType: 'danger',
            onOk: async () => {
                const response = await deleteCategory({ categoryId })
                if ('data' in response) {
                    openNotificationWithIcon('success', 'Category deleted successfully')
                    onSuccess()
                }
            },
        })
    }

    return (
        <Button 
            danger 
            onClick={handleDelete}
            disabled={!hasEditPermission}
        >
            Delete
        </Button>
    )
}

export default DeleteCategoryButton 